import { api } from '@/api';

export interface MerchantSettings {
  webhook_enabled: boolean;
  webhook_url: string;
  transaction_webhook_retry: number;
  transaction_webhook_interval: number;
}

export const settingsService = {
  getSettings: () => api.get<any>('/merchant/v1/merchant-settings/'),
  updateSettings: (data: MerchantSettings) => api.patch<any>('/merchant/v1/merchant-settings/', data),
};
